module.exports = __webpack_public_path__ + "static/media/search.605680c6.png";